import React from 'react';

function BarChartIcon({ className = '' }) {
	return (
		<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className={className}>
			<path d="M4 20V10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
			<path d="M10 20V4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
			<path d="M16 20V13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
			<path d="M22 20V7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
		</svg>
	);
}

function LineChartIcon({ className = '' }) {
	return (
		<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className={className}>
			<path d="M3 17L9 11L13 14L21 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
			<circle cx="3" cy="17" r="1.6" fill="currentColor" />
			<circle cx="9" cy="11" r="1.6" fill="currentColor" />
			<circle cx="13" cy="14" r="1.6" fill="currentColor" />
			<circle cx="21" cy="6" r="1.6" fill="currentColor" />
		</svg>
	);
}

function TableIcon({ className = '' }) {
	return (
		<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className={className}>
			<rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.8" />
			<path d="M3 10H21" stroke="currentColor" strokeWidth="1.8" />
			<path d="M9 5V19" stroke="currentColor" strokeWidth="1.8" />
		</svg>
	);
}

function GaugeIcon({ className = '' }) {
	return (
		<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className={className}>
			<path d="M4 16a8 8 0 1 1 16 0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
			<path d="M12 12l4-3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
			<circle cx="12" cy="12" r="1.5" fill="currentColor" />
		</svg>
	);
}

function FilterIcon({ className = '' }) {
	return (
		<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className={className}>
			<path d="M4 6H20" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
			<path d="M7 12H17" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
			<path d="M10 18H14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
		</svg>
	);
}

export const widgetIconOptions = [
	{ id: 'bar', label: 'Bar Chart', Icon: BarChartIcon },
	{ id: 'line', label: 'Line Chart', Icon: LineChartIcon },
	{ id: 'table', label: 'Table', Icon: TableIcon },
	{ id: 'gauge', label: 'Gauge', Icon: GaugeIcon },
	{ id: 'filter', label: 'Filter', Icon: FilterIcon },
];

export function getWidgetIconById(id) {
	if (!id) return null;
	return widgetIconOptions.find((option) => option.id === id) || null;
}
